import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class MessageService {

  constructor(
    private toastr: ToastrService
  ) { }

  showSuccess(message) {
    this.toastr.success(message);
  }

  showError(error?: HttpErrorResponse, message?: string) {
    if (error && error.message) {
      this.toastr.error(error.message);
    } else if (message) {
      this.toastr.error(message);
    } else {
      this.toastr.error('There is some problem');
    }
  }

  showInfo(message) {
    this.toastr.info(message);
  }

  showWarning(message) {
    this.toastr.warning(message);
  }
}
